import { ADMINISTRATOR, Administrator } from '@favid-inc/api';
import { Delete, Get, Post } from '@favid-inc/api/lib/rest';
import { Filter } from 'core/generic';
import { Action } from 'core/generic';
import { MESSAGE_ERROR, ON_MESSAGE } from 'core/redux/types';
import _ from 'lodash';
import { request as client } from 'utils';
import { Store } from 'utils/Store';
import { State } from './ClaimAdmin';
import {
  BEFORE_PROCESSING,
  ERROR_DELETE_ADMINS,
  ERROR_FETCH_ADMINS,
  ERROR_INSERT_ADMINS,
  ON_DELETE_ADMIN,
  ON_FETCH_ADMINS,
  ON_PUSH_ADMIN,
} from './types';

const instanceOfAdministrator = (object: any): object is Administrator => {
  return 'id' in object;
};

export const reducer = (state: State, { type, payload }: Action) => {
  switch (type) {
    case ON_DELETE_ADMIN:
      if (payload && instanceOfAdministrator(payload)) {
        const list = _.filter(state.list, (adm) => adm.id !== payload.id);
        return { ...state, isLoading: false, list };
      }
      return state;
    case ON_PUSH_ADMIN:
      if (payload && instanceOfAdministrator(payload)) {
        state.list.push(payload);
        return { ...state, isLoading: false, list: state.list };
      }
      return state;
    case ON_FETCH_ADMINS:
      return { ...state, isLoading: false, ...payload };
    case BEFORE_PROCESSING:
      return { ...state, isLoading: true };
    case ERROR_FETCH_ADMINS:
      showMessage('Ocorreu um erro ao listar os administradores', MESSAGE_ERROR);
      return { ...state, isLoading: false, list: [] };
    case ERROR_DELETE_ADMINS:
      showMessage('Ocorreu um erro ao remover o administrador', MESSAGE_ERROR);
      return { ...state, isLoading: false };
    case ERROR_INSERT_ADMINS:
      showMessage('Ocorreu um erro ao inserir o administrador', MESSAGE_ERROR);
      return { ...state, isLoading: false };
    default:
      return state;
  }
};

const showMessage = (description: string, type: string) => {
  const message = {
    description,
    type,
  };

  Store.getInstance().dispatch({
    type: ON_MESSAGE,
    payload: message,
  });
};

export const fetchAdmins = async (filter: Filter, dispatch: (action: Action) => void) => {
  dispatch({
    type: BEFORE_PROCESSING,
  });

  try {
    const request: Get<Administrator>['Request'] = {
      url: `/${ADMINISTRATOR}`,
      method: 'GET',
    };

    const response = await client.request<Get<Administrator>['Response']>(request);
    dispatch({
      type: ON_FETCH_ADMINS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: ERROR_FETCH_ADMINS,
    });
  }
};

export const insertAdmin = async (email: string, dispatch: (action: Action) => void) => {
  dispatch({
    type: BEFORE_PROCESSING,
  });

  try {
    const request: Post<Administrator>['Request'] = {
      url: `/${ADMINISTRATOR}`,
      method: 'POST',
      data: { email },
    };

    const response = await client.request<Post<Administrator>['Response']>(request);
    dispatch({
      type: ON_PUSH_ADMIN,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: ERROR_INSERT_ADMINS,
    });
  }
};

export const deleteAdmin = async (admin: Administrator, dispatch: (action: Action) => void) => {
  dispatch({
    type: BEFORE_PROCESSING,
  });

  try {
    const request: Delete<Administrator>['Request'] = {
      url: `/${ADMINISTRATOR}/${admin.id}`,
      method: 'DELETE',
    };
    await client.request<Delete<Administrator>['Response']>(request);

    dispatch({
      type: ON_DELETE_ADMIN,
      payload: admin,
    });
  } catch (error) {
    dispatch({
      type: ERROR_DELETE_ADMINS,
    });
  }
};
